import React, { useState, useRef } from 'react';
import { Input } from 'components/commons';
import { InputProps } from 'components/commons/input/input';
import editImage from 'assets/svg/edit.svg';
import './edit-in-place.style.scss';


type EditInPlaceProps = {
    label: string;
    name: string;
    type?: 'email';
    value: string;
    onChange:(value: any) => void;
    onBlur?:() => void;
    onFocus?:() => void;
};

const EditInPlace: React.FC<EditInPlaceProps & InputProps> = ({ label, ...props }): JSX.Element => {
    const [inEdition, setInEdition] = useState(false);

    const inputRef = useRef();

    const handleEdit = () => {
        setInEdition(true);

        setTimeout(() => (inputRef.current as HTMLInputElement).focus(), 0);
    }

    return (
        <div className="edit-in-place">
            { label && (
                <label>{ label }</label>
            ) }

            <div className="box">
                <div className={inEdition ? 'show' : 'hide'}>
                    <Input ref={inputRef} {...props} />
                </div>

                <span className={['input-value', !inEdition ? 'show' : 'hide'].join(' ')}>
                    { props.value }
                </span>

                <button type="button" onClick={handleEdit}>
                    <span>editar</span>
                    <img src={editImage} alt="editar"/>
                </button>
            </div>
        </div>
    );
};

export default EditInPlace;
